
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_14q2s_141",
  "parent": "awsui_parent_15o6u_14q2s_160",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_14q2s_160",
  "highlighted": "awsui_highlighted_15o6u_14q2s_160",
  "selected": "awsui_selected_15o6u_14q2s_160",
  "selectable-item-content": "awsui_selectable-item-content_15o6u_14q2s_163",
  "pad-bottom": "awsui_pad-bottom_15o6u_14q2s_167",
  "virtual": "awsui_virtual_15o6u_14q2s_174",
  "has-background": "awsui_has-background_15o6u_14q2s_177",
  "child": "awsui_child_15o6u_14q2s_180",
  "disabled": "awsui_disabled_15o6u_14q2s_186",
  "is-keyboard": "awsui_is-keyboard_15o6u_14q2s_201",
  "visual-refresh": "awsui_visual-refresh_15o6u_14q2s_211",
  "next-item-selected": "awsui_next-item-selected_15o6u_14q2s_225",
  "previous-item-selected": "awsui_previous-item-selected_15o6u_14q2s_235",
  "sticky": "awsui_sticky_15o6u_14q2s_267",
  "with-scrollbar": "awsui_with-scrollbar_15o6u_14q2s_286",
  "after-header": "awsui_after-header_15o6u_14q2s_289",
  "measure-strut": "awsui_measure-strut_15o6u_14q2s_318",
  "screenreader-content": "awsui_screenreader-content_15o6u_14q2s_330",
  "option-content": "awsui_option-content_15o6u_14q2s_336",
  "select-all": "awsui_select-all_15o6u_14q2s_340"
};
  